<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink ref="searching">
        <span style="height: 20px;"><CIcon :height="20" name="cil-group"  /></span>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Mis Cuentas</strong>
      <span v-if="relationships.length > 5" >
      <br /><br />
      <CInput
        class="centered"
        v-model="search"
        :lazy="false"
        placeholder=""
        @change="changeSearch"
      />
      </span>
    </CDropdownHeader>
    <CDropdownDivider v-if="relationships.length > 0" />
    <CDropdownItem v-if="relationships.length > 0" @click="loginPartner(partner)" v-show="partner.fiscal.rfc.includes(search.toUpperCase()) || partner.fiscal.comercial_name.includes(search.toUpperCase())" v-for="(partner, index1) in relationships" :key="'A'+index1">
      <CIcon name="cil-external-link" /> {{partner.fiscal.rfc}}&nbsp; - &nbsp;{{partner.fiscal.fiscal_name}}
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="newAccountModal()">
      <CIcon name="cil-user-follow" /> NUEVA CUENTA
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Cerrar Sesión
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import router from '../router/index'
import store from '../store'
import account_ws from '../services/account';
import login from '../services/login';
import axios from 'axios'

export default {
  name: 'TheHeaderDropdownAccnt',
  components: { }, 
  data () {
    return { 
      rfc: '',
      name: '',
      deadline: '',
      deadline_days: 1000,
      deadline_date: '',
      stamps: 100,
      relationships: [],
      search: ''
    }
  },
  mounted: async function() {
    let response = await account_ws.getFiscalInfo(); 

    if(response.type == "success"){
      this.rfc = response.data.rfc;
      this.name = response.data.fiscal_name;
    }

    let response2 = await account_ws.getAccountDetails(); 

    if(response2.type == "success"){
      this.stamps = response2.data.stamps;
      this.deadline = response2.data.deadline;
      this.deadline_days = response2.data.deadline_days;
      this.deadline_date = response2.data.deadline_date;

      store.commit('setAccount', response2.data.account_id);
      store.commit('setStamps', response2.data.stamps);
      store.commit('setDeadlineDays', response2.data.deadline_days);
      store.commit('setDeadlineDate', response2.data.deadline_date);
    }

    let is_owner = localStorage.getItem("is_owner");
    let owner_id = localStorage.getItem("owner");

    if(is_owner == 1){
      let response_data = await account_ws.getRelationships(owner_id); 

      if(response_data.type == "success"){
        this.relationships = response_data.data;
      }
    }
  },
  methods: {
    loginPartner: async function(partner){
      let response = await login.loginPartner(partner.user.access_token);

      if(response.type == "success"){
        let data = response.data;

        localStorage.setItem("token", data.access_token);

        axios.defaults.headers.common['access-token'] = data.access_token;

        window.location.reload();
      }
      else{
        alert(response.message);
      }
    },
    newAccountModal: function(){
      this.$emit("show");
    },
    refresh: async function(){
      let is_owner = localStorage.getItem("is_owner");
      let owner_id = localStorage.getItem("owner");

      if(is_owner == 1){
        let response_data = await account_ws.getRelationships(owner_id); 

        if(response_data.type == "success"){
          this.relationships = response_data.data;
        }
      }
    },
    logout: function(){
      this.$emit("update", this.form );
      localStorage.removeItem("token");
      localStorage.removeItem("is_owner");
      localStorage.removeItem("owner");
      store.commit('clear');
      router.push("login");
    },
    changeSearch: function(){
      console.log(this.search);
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>